module.exports = __webpack_public_path__ + "img/aboutUs-header-img02.9600e228.png";